const routes = [
    {
        name: 'home',
        path: '/',
        component: () => import('./pages/home')
    }

  ]

  export default routes